const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_ABSENCES_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "REQUEST_ABSENCES_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action,
      };
    case "REQUEST_ABSENCES_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
